//
// Tailwind Toggles
// --------------------------------------------------
// Updates a data-open attribute on target classes when a target element is clicked
// This attribute can be targeted with tailwind styles to display as required
// Toggle once option available for things only wanting to fire once
// Supports overflow handling with data-overflow-open
//
window.addEventListener('load', () => {
    const containersWithToggles = document.querySelector('[data-tw-toggle-container], [data-tw-toggle], #searchPanel');

    if (containersWithToggles) {
        document.addEventListener('click', (event) => {
            const target = event.target;

            function handleToggleClick(container) {
                if (!container) return;

                // Toggle state of data container based on attributes
                if (container.hasAttribute('data-open')) {
                    container.dataset.open = container.dataset.open === 'false' ? 'true' : 'false';
                }

                if (container.hasAttribute('data-open-once') && container.dataset.openOnce === 'false') {
                    container.dataset.openOnce = 'true';
                }

                // Handle overflow logic if data-overflow-open is present
                if (container.hasAttribute('data-overflow-open')) {
                    const accordionContent = container.querySelector('[data-tw-accordion-content] > .overflow-hidden');
                    if (accordionContent) {
                        if (container.dataset.open === 'true') {
                            const onTransitionEnd = (e) => {
                                if (e.target === accordionContent && e.propertyName === 'grid-template-rows') {
                                    if (container.dataset.open === 'true') {
                                        accordionContent.classList.add('group-data-[open=true]/accordion:overflow-visible');
                                    }
                                    accordionContent.removeEventListener('transitionend', onTransitionEnd);
                                }
                            };

                            accordionContent.addEventListener('transitionend', onTransitionEnd);
                        } else {
                            // Remove immediately on close
                            accordionContent.classList.remove('group-data-[open=true]/accordion:overflow-visible');
                        }
                    }
                }
            }

            // Check if the target or its parent is [data-tw-toggle]
            if (target.matches('[data-tw-toggle]') || target.parentElement?.matches('[data-tw-toggle]')) {
                const toggleContainer = target.closest('[data-tw-toggle-container]');
                if (toggleContainer) {
                    handleToggleClick(toggleContainer);
                }
            }
        });
    }
});
